import { queryClient } from '@/lib/react-query'

const SESSION_SWAP_PRESERVED_ROOTS = new Set(['auth'])
const SUPER_ADMIN_QUERY_ROOT = 'superAdminData'

/** Queries métier à purger lors d'un swap impersonation. */
export function isSessionSwapClearableQuery(query, options = {}) {
  if (!Array.isArray(query.queryKey) || query.queryKey.length === 0) {
    return false
  }
  const root = String(query.queryKey[0])
  if (SESSION_SWAP_PRESERVED_ROOTS.has(root)) {
    return false
  }
  if (options.preserveSuperAdminData && root === SUPER_ADMIN_QUERY_ROOT) {
    return false
  }
  return true
}

/**
 * Purge le cache métier avant hydrate/navigate — évite le flash de données stale
 * puis refetch échelonné. Les queries de la page cible partent en parallèle au mount.
 */
export function clearSessionSwapQueries(options = {}) {
  queryClient.removeQueries({
    predicate: (query) => isSessionSwapClearableQuery(query, options),
  })
}

/**
 * Invalide toutes les queries (appelé lors du switch d'équipe)
 * Mais préserve les queries qui ne sont pas spécifiques à une équipe
 */
export function invalidateAllTeamQueries() {
  queryClient.invalidateQueries({
    predicate: (query) => {
      const queryKey = query.queryKey
      // Ne pas invalider les queries globales (userTeams, teamRole, etc.)
      if (Array.isArray(queryKey)) {
        const keyString = queryKey.join(',')
        // Invalider seulement les queries qui contiennent des données spécifiques à une équipe
        // mais pas les queries de configuration (userTeams, teamRole)
        return !keyString.includes('userTeams') && 
               !keyString.includes('teamRole') &&
               !keyString.includes('freelancerTeams') // Garder la compatibilité — team,context est invalidé
      }
      return false
    }
  })
}
